/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Body of the complexity-only update.
 * @export
 * @interface ProblemComplexityUpdate
 */
export interface ProblemComplexityUpdate {
    /**
     * 
     * @type {number}
     * @memberof ProblemComplexityUpdate
     */
    complexity: number;
}

/**
 * Check if a given object implements the ProblemComplexityUpdate interface.
 */
export function instanceOfProblemComplexityUpdate(value: object): value is ProblemComplexityUpdate {
    if (!('complexity' in value) || value['complexity'] === undefined) return false;
    return true;
}

export function ProblemComplexityUpdateFromJSON(json: any): ProblemComplexityUpdate {
    return ProblemComplexityUpdateFromJSONTyped(json, false);
}

export function ProblemComplexityUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProblemComplexityUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'complexity': json['complexity'],
    };
}

export function ProblemComplexityUpdateToJSON(json: any): ProblemComplexityUpdate {
    return ProblemComplexityUpdateToJSONTyped(json, false);
}

export function ProblemComplexityUpdateToJSONTyped(value?: ProblemComplexityUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'complexity': value['complexity'],
    };
}

